export enum SelfFixFeature {}
